import React from 'react'

import './index.scss'

export const RelationshipIcon: React.FC = () => (
  <svg className="icon icon--relationship" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
    <path
      className="stroke"
      d="M19.0597 14.9691L19.0597 19.0946L6.01681 19.0946L6.01681 6.03028L10.0948 6.03028"
      strokeWidth="2"
    />
    <path className="stroke" d="M19.0597 11.0039L19.0597 6.00387L14.0597 6.00387" strokeWidth="2" />
    <line className="stroke" strokeWidth="2" x1="18.7061" x2="13.0493" y1="6.40767" y2="12.0645" />
  </svg>
)
